import type registerZh from '../zh/register';

const register: typeof registerZh = {
  password_mismatch: 'Hai lần nhập mật khẩu không khớp',
  email_invalid: 'Vui lòng nhập địa chỉ email hợp lệ!',
  email_incorrect: 'Vui lòng nhập email hợp lệ',
  title: '米通 | Đăng ký quản trị',
  email_placeholder: 'Nhập email',
  send_code: 'Gửi mã xác minh',
  password_again: 'Nhập lại mật khẩu'
};

export default register;
